export default {
  mounted(el) {
    el.addEventListener('click', () => {
      el.blur()
    })
  }
}
